export default [
    {
        "name": "全部",
        "code": "11000",
        "city": [
            {
                "name": "华为",
                "code": "1",
            },
            {
                "name": "小米",
                "code": "2",
            },
            {
                "name": "VIVO",
                "code": "3",
            },
            {
                "name": "魅族",
                "code": "4",
            },
            {
                "name": "OPPO",
                "code": "5",
            },
            {
                "name": "三星",
                "code": "6",
            },
            {
                "name": "金立",
                "code": "7",
            },
            {
                "name": "努比亚",
                "code": "8",
            },
						{
						    "name": "联想",
						    "code": "9",
						},
						{
						    "name": "其他",
						    "code": "10",
						}
        ]
    },
]
